import { LAUNCH_DATE } from "./launch.ts";

/**
 * Maps the player's local calendar date to a 1-based day index, with no
 * server involved — every player on the same local date sees the same day.
 *
 * Both the launch date and "today" are converted through `Date.UTC` on their
 * Y/M/D components before diffing, rather than subtracting `Date` instances
 * directly — a raw ms diff can land on a fractional day around a DST
 * transition, which is exactly the kind of bug that only shows up twice a
 * year.
 */

/**
 * Day 1.
 *
 * The Monday before launch, chosen so the calendar lands players where the
 * curriculum is worth their time.
 *
 * Launch is Saturday 22 August, which is day 6. Days 6 to 13 are wall-free --
 * four Core mechanic boards, then four irregular outlines so the silhouette
 * changes while the rule does not. Walls arrive on day 14, the Sunday after
 * launch: a week to learn the one rule, then the first rule beyond it.
 *
 * A Monday, which the schedule assumes and the original launch date did not:
 * the week term in data/schedule.json shapes a gentle Monday and a chewy
 * Saturday, and launching on a Thursday had that rhythm running three days
 * out from the real week.
 */


function utcDays(year: number, month: number, day: number): number {
  return Date.UTC(year, month - 1, day) / 86_400_000;
}

/** 1-based day index for the player's local "today". Not clamped to the schedule length. */
export function todayDayIndex(): number {
  const now = new Date();
  const today = utcDays(now.getFullYear(), now.getMonth() + 1, now.getDate());
  const launch = utcDays(LAUNCH_DATE.year, LAUNCH_DATE.month, LAUNCH_DATE.day);
  return today - launch + 1;
}
